import React from 'react';
import { Calendar, Clock, MapPin, ChevronRight, CheckCircle } from 'lucide-react';
import { useApp } from '../context/AppContext';

const BookingsView = () => {
    const { bookings } = useApp();
    const activeBookings = bookings; // Using global state now

    return (
        <div className="bookings-view animate-fade">
            <div className="bookings-header">
                <h2>My Bookings</h2>
                <p>Manage your appointments and services.</p>
            </div>

            <div className="status-filters">
                <button className="active">Upcoming</button>
                <button>Past</button>
                <button>Cancelled</button>
            </div>

            {activeBookings.length > 0 ? (
                <div className="bookings-list">
                    {activeBookings.map(booking => (
                        <div key={booking.id} className="booking-card card">
                            <div className="booking-main">
                                <div className="booking-info">
                                    <span className="type-tag">{booking.type}</span>
                                    <h4>{booking.provider}</h4>
                                    <div className="meta">
                                        <Clock size={12} /> <span>{booking.time}</span>
                                    </div>
                                </div>
                                <div className="status-box">
                                    <CheckCircle size={16} color={booking.status === 'Confirmed' ? 'var(--primary-green)' : 'var(--text-light)'} />
                                    <span>{booking.status}</span>
                                </div>
                            </div>
                            <div className="booking-actions">
                                <button className="secondary-btn sm">Chat</button>
                                <button className="primary-btn sm">View Details</button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <p>No active bookings found.</p>
                </div>
            )}

            <style dangerouslySetInnerHTML={{
                __html: `
        .bookings-header { margin-bottom: 24px; }
        .bookings-header p { font-size: 14px; color: var(--text-light); }
        
        .status-filters { display: flex; gap: 8px; margin-bottom: 24px; }
        .status-filters button { padding: 8px 16px; border-radius: 20px; background: white; border: 1px solid var(--border-gray); font-size: 13px; font-weight: 600; color: var(--text-light); }
        .status-filters button.active { background: var(--primary-green); color: white; border-color: var(--primary-green); }

        .booking-card { margin-bottom: 16px; }
        .booking-main { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
        .type-tag { font-size: 10px; font-weight: 700; color: var(--primary-green); background: var(--light-green); padding: 2px 6px; border-radius: 4px; margin-bottom: 4px; display: inline-block; }
        .booking-info h4 { font-size: 16px; margin-bottom: 4px; }
        .meta { display: flex; align-items: center; gap: 4px; font-size: 12px; color: var(--text-light); }
        
        .status-box { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
        .status-box span { font-size: 11px; font-weight: 700; color: var(--text-light); }

        .booking-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; border-top: 1px solid var(--border-gray); padding-top: 12px; }
        .empty-state { text-align: center; padding: 40px 0; color: var(--text-light); }
      `}} />
        </div>
    );
};

export default BookingsView;
